export default __webpack_public_path__ + "static/media/LogoSanNicola.b918165e.webp";